import { EntityActivities } from '@/entities/activity/constants';
import { LogEntityComponent } from '@/ui/components/activityLogs/factory/LogEntityComponent';

export abstract class LogComponentCreator {
  public abstract componentFactory(): LogEntityComponent;

  public logEntityComponentFactory(activity: EntityActivities) {
    const logComponent = this.componentFactory();
    return logComponent.getComponent(activity);
  }
}
